import { render, staticRenderFns } from "./PublicationInfo.vue?vue&type=template&id=595a5080"
import script from "./PublicationInfo.vue?vue&type=script&lang=js"
export * from "./PublicationInfo.vue?vue&type=script&lang=js"
import style0 from "./PublicationInfo.vue?vue&type=style&index=0&id=595a5080&prod&%40scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports